import $ from "jquery";
import "slick-carousel";

$(".gallery-slider").slick({
  dots: false,
  infinite: true,
  speed: 600,
  fade: true,
  cssEase: "linear"
});

$(".block-comments-items").slick({
  speed: 600,
  slidesToShow: 3,
  infinite: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$(".car-item-slider .container-slides").slick({
  speed: 600,
  slidesToShow: 1,
  infinite: true,
  variableWidth: true,
  centerMode: true,
  lazyLoad: "ondemand",
  slidesToScroll: 3
});
